import { Empty } from '@/components/ui/EmptyState';
import { YStack } from '@/components/ui/layout/layout';

import type { ReactNode } from 'react';

export const UsageCard = ({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}) => (
  <YStack className="gap-3 rounded-xl border border-border bg-surface px-6 py-4 dark:border-border-strong">
    <YStack className="gap-0.5">
      <span className="text-base font-medium text-foreground">{title}</span>
      <span className="text-sm text-foreground-muted">{subtitle}</span>
    </YStack>
    {children}
  </YStack>
);

export const UsageCardEmpty = ({
  title,
  description,
  className = 'flex-1 justify-center',
}: {
  title: string;
  description: string;
  className?: string;
}) => (
  <Empty.Root variant="compact" className={className}>
    <Empty.Header>
      <Empty.Title className="text-base">{title}</Empty.Title>
      <Empty.Description>{description}</Empty.Description>
    </Empty.Header>
  </Empty.Root>
);
